import { $, $$ } from '../utils/dom.js';

export function initMapSlider() {
  const disposers = $$('[data-component="map-slider"]').map((root) => setupMapSlider(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setupMapSlider(root) {
  const slides = $$('[data-map-slide]', root);
  const dots = $$('[data-map-dot]', root);
  const prevBtn = $('[data-map-slider-prev]', root);
  const nextBtn = $('[data-map-slider-next]', root);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (slides.length < 2) {
    return () => {};
  }

  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (activeIndex < 0) {
    activeIndex = 0;
  }

  const clampIndex = (index) => Math.max(0, Math.min(index, slides.length - 1));

  const updateControls = (index) => {
    const hasPrev = index > 0;
    const hasNext = index < slides.length - 1;

    prevBtn?.classList.toggle('is-active', hasPrev);
    prevBtn?.classList.toggle('is-inactive', !hasPrev);
    prevBtn?.setAttribute('aria-disabled', hasPrev ? 'false' : 'true');

    nextBtn?.classList.toggle('is-active', hasNext);
    nextBtn?.classList.toggle('is-inactive', !hasNext);
    nextBtn?.setAttribute('aria-disabled', hasNext ? 'false' : 'true');
  };

  const setActive = (index) => {
    const nextIndex = clampIndex(index);

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    dots.forEach((dot) => {
      const dotIndex = Number(dot.getAttribute('data-map-dot'));
      dot.classList.toggle('is-active', dotIndex === nextIndex);
    });

    activeIndex = nextIndex;
    updateControls(nextIndex);
  };

  const onPrev = () => {
    if (activeIndex > 0) {
      setActive(activeIndex - 1);
    }
  };

  const onNext = () => {
    if (activeIndex < slides.length - 1) {
      setActive(activeIndex + 1);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === 'ArrowLeft' && activeIndex > 0) {
      event.preventDefault();
      onPrev();
    }

    if (event.key === 'ArrowRight' && activeIndex < slides.length - 1) {
      event.preventDefault();
      onNext();
    }
  };

  prevBtn?.addEventListener('click', onPrev);
  nextBtn?.addEventListener('click', onNext);
  root.addEventListener('keydown', onKeyDown);

  dots.forEach((dot) => {
    const index = Number(dot.getAttribute('data-map-dot'));
    const location = slides[index]?.querySelector('.map-slider__location')?.textContent?.trim();

    dot.addEventListener('click', () => {
      if (!Number.isNaN(index)) {
        setActive(index);
      }
    });

    dot.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (!Number.isNaN(index)) {
          setActive(index);
        }
      }
    });

    dot.setAttribute('role', 'button');
    dot.setAttribute('tabindex', '0');

    if (location) {
      dot.setAttribute('aria-label', `Show ${location}`);
    }
  });

  root.setAttribute('tabindex', '0');

  if (reduceMotion) {
    root.classList.add('is-reduced-motion');
  }

  setActive(activeIndex);

  return () => {
    prevBtn?.removeEventListener('click', onPrev);
    nextBtn?.removeEventListener('click', onNext);
    root.removeEventListener('keydown', onKeyDown);
    root.classList.remove('is-reduced-motion');
  };
}
